// Deep-link into the marketer Expert page with a question pre-filled in the
// composer. AIExpertPage honours ?prompt= when embedded: it auto-starts a
// conversation and places the text in the input — it never auto-sends, so the
// user reviews and owns the question before it reaches the expert. Shared so
// any dashboard read-out (The Fix today, recommendation cards later) can hand
// its finding to the Head of Brand Marketing.

import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useMarketerRoot } from '../../hooks/useDashboardConfig';

// djb2 over the framed question (same pattern as playStableId): the same fix
// always maps to the same context key, so a second click reopens the user's
// existing conversation server-side instead of starting a duplicate.
function contextKeyFor(prompt: string): string {
  let hash = 5381;
  for (let i = 0; i < prompt.length; i += 1) {
    hash = ((hash << 5) + hash + prompt.charCodeAt(i)) >>> 0;
  }
  return `ask_${hash.toString(36)}`;
}

export function useAskExpert(): (prompt: string) => void {
  const navigate = useNavigate();
  const { brandHash } = useParams();
  const root = useMarketerRoot();
  return useCallback(
    (prompt: string) => {
      const params = new URLSearchParams({ prompt, context: contextKeyFor(prompt) });
      navigate(`${root}/${brandHash}/expert?${params.toString()}`);
    },
    [navigate, brandHash, root],
  );
}
